import { render, staticRenderFns } from "./PGD.vue?vue&type=template&id=e1c6cf36&"
import script from "./PGD.vue?vue&type=script&lang=js&"
export * from "./PGD.vue?vue&type=script&lang=js&"
import style0 from "./PGD.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports